export const Plausible = {
  sync(state, { scriptUrl, domain } = {}) {
    if (!domain) return;
    const existing = document.head.querySelector(`script[data-domain="${domain}"][data-cmp-managed="1"]`);
    if (state.measurement) {
      if (existing || !scriptUrl) return;
      const s = document.createElement('script');
      s.defer = true;
      s.src = scriptUrl;
      s.dataset.domain = domain;
      s.dataset.cmpManaged = '1';
      document.head.appendChild(s);
    } else if (existing) {
      existing.remove();
    }
  },
};
